export default {
      id: "chevron-right-usage",
      viewBox: "0 0 14 23",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#chevron-right",
      toString: function () {
        return this.url;
      }
    }